import { TApplicationState } from '../../types/redux';

export function getNewbuildingCoordinates(state: TApplicationState) {
  const {
    newbuilding: {
      geo: { coordinates },
    },
  } = state;

  return coordinates;
}
